export default "__VITE_ASSET__El7E_d$z__"